import { render, staticRenderFns } from "./qrcClaim.vue?vue&type=template&id=0e2e6115&scoped=true&class=bg-light&"
import script from "./qrcClaim.vue?vue&type=script&lang=js&"
export * from "./qrcClaim.vue?vue&type=script&lang=js&"
import style0 from "./qrcClaim.vue?vue&type=style&index=0&id=0e2e6115&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2e6115",
  null
  
)

export default component.exports